
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"28.09"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 721","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6890","d":"M30 16.054a8.759 8.759 0 01-4.173-5.382V6.743a10.256 10.256 0 00.973.617l.726-1.31A8.74 8.74 0 0123.34.61a.748.748 0 00-.736-.611H7.392a.748.748 0 00-.736.611A8.658 8.658 0 012.47 6.05l.725 1.31a10.194 10.194 0 00.973-.617v3.929a8.758 8.758 0 01-4.173 5.382l.726 1.31c.278-.154.539-.316.787-.485V28.09h1.5V16.699h23.984v11.392h1.5V16.879c.248.168.51.331.788.485zM5.671 6.423H24.33v3.584H5.671zm-.172 5.081h19a10.307 10.307 0 002.082 3.7H3.417a10.3 10.3 0 002.082-3.702zm2.475-10h14.052a10.317 10.317 0 001.853 3.419H6.122a10.316 10.316 0 001.852-3.426z"}}),_c('path',{attrs:{"data-name":"Path 6891","d":"M7.38 18.947a3.123 3.123 0 00-3.119 3.12v6.023h1.5v-6.023a1.622 1.622 0 113.244 0v6.023h1.5v-6.023a3.123 3.123 0 00-3.125-3.12z"}}),_c('path',{attrs:{"data-name":"Path 6892","d":"M15.001 18.947a3.123 3.123 0 00-3.12 3.12v6.023h1.5v-6.023a1.622 1.622 0 113.244 0v6.023h1.5v-6.023a3.123 3.123 0 00-3.124-3.12z"}}),_c('path',{attrs:{"data-name":"Path 6893","d":"M22.62 18.947a3.123 3.123 0 00-3.119 3.12v6.023h1.5v-6.023a1.622 1.622 0 113.244 0v6.023h1.5v-6.023a3.123 3.123 0 00-3.125-3.12z"}}),_c('path',{attrs:{"data-name":"Rectangle 219","d":"M5.858 17.107h3.045v1.497H5.858z"}}),_c('path',{attrs:{"data-name":"Rectangle 220","d":"M13.478 17.107h3.045v1.497h-3.045z"}}),_c('path',{attrs:{"data-name":"Rectangle 221","d":"M21.098 17.107h3.045v1.497h-3.045z"}}),_c('path',{attrs:{"data-name":"Rectangle 222","d":"M7.38 7.502h15.24v1.497H7.38z"}})])])
          )
        }
      }
    